module.exports = __webpack_public_path__ + "static/media/8OLA26.16759e96.jpg";